<template>
  <div>
    <!-- 第三方接口调用记录 -->
    <a-card title="第三方接口调用记录" style="margin: 20px">
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>API编号</span>
          <a-select
            v-model="paramsData.apiNos"
            placeholder="请选择API编号"
            allowClear
            show-search
            mode="multiple"
            :filter-option="filterOption"
            style="width: 350px"
          >
            <a-select-option v-for="item in apiEnumList" :key="item.apiNo" :value="item.apiNo">
              {{ item.apiNo }} - {{ item.apiName }}
            </a-select-option>
          </a-select>
        </div>
        <div class="item">
          <span>请求流水号</span>
          <a-input v-model.trim="paramsData.reqSerialNo" placeholder="请输入请求流水号" allow-clear style="width: 200px"/>
        </div>
        <div class="item">
          <span>请求时间</span>
          <a-range-picker
            v-model="dateRange"
            :show-time="{ format: 'HH:mm:ss' }"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
            @change="onDateChange"
            style="width: 380px"
          />
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="handleQuery">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table
            :columns="columns"
            :data-source="tableData"
            :loading="loading"
            :pagination="false"
            :scroll="{ x: 1200 }"
            row-key="id"
          >
            <template slot="reqTime" slot-scope="text">
              {{ text ? formatDateTime(text) : '-' }}
            </template>
            <template slot="rspTime" slot-scope="text">
              {{ text ? formatDateTime(text) : '-' }}
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="pagination-wrapper">
        <LoadMorePagination
          :loading="loading"
          :has-more="hasMore"
          :fn="loadMore"
        />
      </div>
    </a-card>

    <!-- 详情弹窗（已优化样式） -->
    <a-modal
        v-model="detailVisible"
        title="接口调用详情"
        width="50%"
        :footer="null"
        :destroyOnClose="true"
        wrapClassName="api-detail-modal"
    >
      <a-descriptions bordered :column="2" size="small">
        <a-descriptions-item label="API编号">{{ detailData.apiNo || '-' }}</a-descriptions-item>
        <a-descriptions-item label="API名称">{{ detailData.apiName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="API地址" :span="2">{{ detailData.apiUr || '-' }}</a-descriptions-item>
        <a-descriptions-item label="请求流水号">{{ detailData.reqSerialNo || '-' }}</a-descriptions-item>
        <a-descriptions-item label="请求时间">{{ detailData.reqTime ? formatDateTime(detailData.reqTime) : '-' }}</a-descriptions-item>
        <a-descriptions-item label="应答时间">{{ detailData.rspTime ? formatDateTime(detailData.rspTime) : '-' }}</a-descriptions-item>
      </a-descriptions>
      <div style="display: flex; gap: 16px; margin-top: 16px;">
        <!-- 请求报文 -->
        <div style="flex: 1; min-width: 0;">
          <h4 style="margin: 0 0 8px 0;">请求报文</h4>
          <div class="json-box">
            <pre>{{ formatJson(detailData.reqData) }}</pre>
          </div>
        </div>
        <!-- 应答报文 -->
        <div style="flex: 1; min-width: 0;">
          <h4 style="margin: 0 0 8px 0;">应答报文</h4>
          <div class="json-box">
            <pre>{{ formatJson(detailData.rspData) }}</pre>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import LoadMorePagination from "@/view/components/LoadMorePagination.vue";

export default {
  name: 'ThirdApiRecord',
  components: {LoadMorePagination},
  data() {
    return {
      paramsData: {
        apiNos: [],
        reqSerialNo: '',
        startTime: null,
        endTime: null
      },
      dateRange: [],
      pagination: {
        cursor: null,
        pageSize: 10
      },
      tableData: [],
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => index + 1,
          align: "center",
          width: 60
        },
        {
          title: "API编号",
          dataIndex: "apiNo",
          align: "center",
          width: 120,
          ellipsis: true,
        },
        {
          title: "API名称",
          dataIndex: "apiName",
          align: "center",
          width: 200,
          ellipsis: true,
        },
        {
          title: "请求流水号",
          dataIndex: "reqSerialNo",
          align: "center",
          width: 180,
          ellipsis: true,
          customRender: (text, record) => <a-button type="link" onClick={() => this.viewDetail(record)} style="padding: 0">{text || '-'}</a-button>
        },
        {
          title: "请求时间",
          dataIndex: "reqTime",
          align: "center",
          width: 180,
          scopedSlots: {customRender: 'reqTime'}
        },
        {
          title: "应答时间",
          dataIndex: "rspTime",
          align: "center",
          width: 180,
          scopedSlots: {customRender: 'rspTime'}
        }
      ],
      detailVisible: false,
      detailData: {},
      apiEnumList: [],
      loading: false,
      hasMore: true
    };
  },
  mounted() {
    this.loadApiEnums();
    this.getTableData();
  },
  methods: {
    async loadApiEnums() {
      try {
        const res = await this.api.thirdApiRecordApiEnumsApi();
        if (res.code === 200) {
          const data = res.data || [];
          const seen = new Set();
          this.apiEnumList = data.filter(item => {
            if (seen.has(item.apiNo)) return false;
            seen.add(item.apiNo);
            return true;
          });
        }
      } catch (error) {
        console.error('获取API枚举列表失败:', error);
      }
    },

    filterOption(input, option) {
      const text = option.componentOptions.children[0].text.toLowerCase();
      const parts = text.split(' - ');
      const apiNo = parts[0] || '';
      const apiName = parts[1] || '';
      const keyword = input.toLowerCase();
      return apiNo.indexOf(keyword) >= 0 || apiName.indexOf(keyword) >= 0;
    },

    async getTableData() {
      this.loading = true;
      try {
        const res = await this.api.thirdApiRecordPageApi({
          ...this.paramsData,
          cursor: this.pagination.cursor,
          pageSize: this.pagination.pageSize
        });
        if (res.code === 200) {
          if (this.pagination.cursor === null) {
            this.tableData = res.data.records || [];
          } else {
            this.tableData = [...this.tableData, ...(res.data.records || [])];
          }
          this.pagination.cursor = res.data.nextCursor;
          this.hasMore = res.data.hasMore;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      } finally {
        this.loading = false;
      }
    },

    handleQuery() {
      this.pagination.cursor = null;
      this.tableData = [];
      this.hasMore = true;
      this.getTableData();
    },

    loadMore() {
      if (!this.hasMore || this.loading) return;
      this.getTableData();
    },

    handleReset() {
      this.paramsData = {
        apiNos: [],
        reqSerialNo: '',
        startTime: null,
        endTime: null
      };
      this.dateRange = [];
      this.pagination.cursor = null;
      this.tableData = [];
      this.hasMore = true;
      this.getTableData();
    },

    onDateChange(value, dateStrings) {
      this.paramsData.startTime = dateStrings[0] || null;
      this.paramsData.endTime = dateStrings[1] || null;
    },

    async viewDetail(record) {
      try {
        const res = await this.api.thirdApiRecordDetailApi(record.id);
        if (res.code === 200) {
          this.detailData = res.data;
          this.detailVisible = true;
        } else {
          message.warning(res.info || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        message.error("获取详情失败");
      }
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        return new Date(dateTime).toLocaleString('zh-CN');
      } catch (e) {
        return dateTime;
      }
    },

    formatJson(str) {
      if (!str) return '-';
      try {
        return JSON.stringify(JSON.parse(str), null, 2);
      } catch (e) {
        return str;
      }
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 280px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-radius: 0 0 6px 6px;
}

.json-box {
  max-height: 400px;
  overflow-y: auto;
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 12px;
  }
}

/* 优化详情弹窗中请求/应答区域高度对称 */
.api-detail-modal {
  .json-box {
    height: 400px;
    max-height: 400px;
  }
}
</style>